import {
    FilterType,
} from 'app/enums/common.enums'
import {
    convertFilterValueToObjectSelector, convertObjectValueToFilter,
    FilterConfig,
} from 'app/hooks/useFilter'
import {
    OpportunityType,
} from '../opportunities.types'

const filterConfig: FilterConfig<keyof Pick<OpportunityType,
    'temperatureRange' | 'account' | 'frequency' |
    'airline' | 'reprOriginAirport' | 'reprDestinationAirport' |
    'palletType' | 'competitorsPackaging' | 'currentPackagingSolution' | 'collaborators'>> = {
        account: {
            filterField: 'accountId',
            filterType: FilterType.Array,
            preselectOptions: {
                componentName: 'AccountSelector',
                filterToValueConverter: convertFilterValueToObjectSelector,
                onChangeConverter: convertObjectValueToFilter,
                placeholder: 'Select Account',
                noneOption: false,
                requestParams: {
                    filters: {
                        existsInRegionalGroups: true,
                    },
                },
            },
        },
        temperatureRange: {
            filterField: 'temperatureRange',
            filterType: FilterType.Array,
        },
        frequency: {
            filterField: 'frequency',
            filterType: FilterType.Array,
        },
        airline: {
            filterField: 'airlineName',
            filterType: FilterType.Array,
        },
        reprOriginAirport: {
            filterField: 'reprOriginAirport',
            filterType: FilterType.Array,
        },
        reprDestinationAirport: {
            filterField: 'reprDestinationAirport',
            filterType: FilterType.Array,
        },
        palletType: {
            filterField: 'palletType',
            filterType: FilterType.Array,
        },
        competitorsPackaging: {
            filterField: 'competitorsPackaging',
            filterType: FilterType.Array,
        },
        currentPackagingSolution: {
            filterField: 'currentPackagingSolution',
            filterType: FilterType.Array,
        },
        collaborators: {
            filterField: 'collaboratorsUserName',
            filterType: FilterType.Array,
        },
    }

export default filterConfig
